import { ReactElement } from "react";
import type { ArticleDataObject } from "@app/types/Cue";
import { KeywordStoriesRowProps } from "@app/types/Verticals";
import VerticalLatest from "@components/ArticleCard/VerticalLatest";
import SeeMore from "@components/SeeMore/SeeMore";
import VerticalBlockTitle from "@components/VerticalBlockTitle/VerticalBlockTitle";

export default function GarageKeywordStoriesRow({
  seeMoreLink,
  verticalName,
  verticalBlockTitle,
  data = [],
}: KeywordStoriesRowProps): ReactElement {
  const keywordStories1 = data?.slice(0, 2) ?? [];
  const keywordStories2 = data?.slice(2, 4) ?? [];

  return (
    <>
      {data.length > 1 ? (
        <div>
          <VerticalBlockTitle text={verticalBlockTitle} rootClassName="mb-5" />

          <>
            {keywordStories1?.map(
              (article: ArticleDataObject, index: number) => (
                <VerticalLatest
                  articleData={article}
                  rootClassName="mb-4 pb-4 border-b border-gray-250"
                  key={index}
                  verticalName={verticalName}
                />
              )
            )}
          </>

          <>
            {keywordStories2?.map(
              (article: ArticleDataObject, index: number) => (
                <VerticalLatest
                  articleData={article}
                  rootClassName="mb-4 pb-4 border-b border-gray-250"
                  key={index}
                  verticalName={verticalName}
                />
              )
            )}
          </>

          <>
            {data.length > 2 ? (
              <SeeMore
                text="View More"
                verticalName={verticalName}
                link={seeMoreLink}
              />
            ) : null}
          </>
        </div>
      ) : null}
    </>
  );
}
